import { render, staticRenderFns } from "./nxMobileCheckbox.vue?vue&type=template&id=4fb694c4&scoped=true&"
import script from "./nxMobileCheckbox.vue?vue&type=script&lang=js&"
export * from "./nxMobileCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb694c4",
  null
  
)

export default component.exports